import script from "./CartMulti.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartMulti.vue?vue&type=script&setup=true&lang=ts"

import "./CartMulti.vue?vue&type=style&index=0&id=fddc9b62&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fddc9b62"]])

export default __exports__